import '../shared/types';

/**
 * @typedef {object} StatComparisonState
 * @property {StatComparisonNavState} nav
 * @property {StatComparisonDataTypeState} dataType
 * @property {StatComparisonRequestDetails[]} requests
 * @property {any} data
 */

/**
 * @typedef {object} StatComparisonNavState
 * @property {string} category
 * @property {object} competition
 * @property {number|null} competition.id
 * @property {object} season
 * @property {number|null} season.id
 */

/**
 * @typedef {object} StatComparisonDataTypeState
 * @property {'totals'|'averages'|'benchmarkedTotals'|'benchmarkedAverages'} dataType.type
 */

/**
 * @typedef {object} StatComparisonRequestDetails
 * @property {string} id
 * @property {'rounds'|'seasons'} type
 */
